<template>
  <div class="col-sm-12">
    <div class="card">
      <div class="dropdown-item date-item mt-4">
        <div class="date-grid">
          <div class="date-search-container">
            <div class="row m-l-5 m-r-5">

              <!-- First Row with 4 items -->
              <div class="col-md-3 form-group ">
                <label for="orderDateTimePicker">Loading Date and Time <span>*</span> </label>
                <input type="datetime-local" v-model="orderDateTime" class="search-input" :min="currentDateTime" />
              </div>

              <div class="col-md-3 form-group">
                <label for="unloadingDateTimePicker">Unloading Date and Time <span>*</span></label>
                <input type="datetime-local" v-model="unloadingDateTime" class="search-input" :min="currentDateTime" />
              </div>

              <div class="col-md-3 form-group">
                <label for="distributor">Distributor <span>*</span></label>
                <select v-model="distributor" id="distributor" class="search-input">
                  <option disabled value="">Select Distributor</option>
                  <option v-for="distributor in distributors" :key="distributor.profile_id" :value="distributor.profile_id">{{distributor.name}}</option>
                </select>
              </div>

              <div class="col-md-3 form-group">
                <label for="bridging">Bridging <span>*</span></label>
                <select v-model="bridging" id="bridging" class="search-input">
                  <option disabled value="">Select Bridging</option>
                  <option v-for="bridge in bridgings" :key="bridge.id" :value="bridge.id">{{ bridge.name }}</option>
                </select>
              </div>
            </div>

            <div class="row m-l-5 m-r-5">
              <!-- Second Row with remaining items -->
              <div class="col-md-3 form-group">
                <label for="bridging">Bridging Type <span>*</span></label>
                <select v-model="britype" id="bridging" class="search-input">
                  <option disabled value="">Select Bridging Type</option>
                  <option v-for="britype in britypes" :key="britype.id" :value="britype.id">{{ britype.vehicle_type }}</option>
                </select>
              </div>

              <div class="col-md-3 form-group" v-if="bridging === 2">
                <label for="vehicle">Vehicle <span>*</span></label>
                <select v-model="vehicle" id="vehicle" class="search-input">
                  <option disabled value="">Select Vehicle</option>
                  <option v-for="vehicle in vehicles" :key="vehicle.id" :value="vehicle.id">{{ vehicle.vehicle_no }}</option>
                </select>
              </div>

              <div class="col-md-3 form-group">
                <label for="plant">Plant <span>*</span></label>
                <select v-model="plant" id="plant" class="search-input">
                  <option disabled value="">Select Plant</option>
                  <option v-for="plant in plants" :key="plant.id" :value="plant.id">{{ plant.name }}</option>
                </select>
              </div>

              <div class="col-md-3 form-group">
                <label for="destination">Destination <span>*</span></label>
                <textarea v-model="destination" id="destination" class="search-input" rows="1" placeholder="Enter Destination"></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Loading Spinner -->
      <div v-if="loading" class="loading-spinner mt-3">
        <i class="fa fa-spinner fa-spin"></i> Loading...
      </div>

      <!-- Dispatch Table -->
      <div class="row m-l-5 m-r-5">
        <div class="table-responsive">
          <table class="table">
            <thead>
            <tr class="border-bottom-primary">
              <th scope="col">Item</th>
              <th scope="col">Quantity</th>
              <th scope="col">Action</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in bootstraplist" :key="index">
              <td>{{ item.item_name }}</td>
              <td>
                <input
                    type="number"
                    class="form-control quantity-input"
                    min="0"
                    placeholder="0"
                    ref="quantityInputs"
                    @wheel="$event.target.blur()"
                />
              </td>
              <td>
                <i @click="deleteItem(index)" class="fa fa-trash action-icon" aria-hidden="true"></i>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- New remark section -->
      <div class="remark-section mt-4 p-3">
        <label for="remark">Remarks:</label>
        <textarea
            v-model="remark"
            id="remark"
            class="form-control"
            ref="remarkTextarea"
            @input="adjustTextareaHeight"
            placeholder="Add your remarks here..."
        ></textarea>
      </div>

      <div class="d-flex justify-content-end p-3">
        <button
            type="button"
            class="btn btn-success"
            @click="issueGatePass"
            :disabled="!isFormValid || loading2"
        >
          <span v-if="loading2" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <span v-else>Request</span>
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import { useRouter } from 'vue-router';
import {
  fetchDistributorListOrderRequest,
  fetchVehicleListOrderRequest,
  fetchPlantOrderRequest,
  fetchBridgingList,
  fetchItemNameListOrder,
  savePurchaseOrder,
  fetchVehicleType
} from '@/services/dataService';
import { useToast } from 'vue-toastification';

export default {
  data() {
    const now = new Date();
    const currentDateTime = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}T${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
    return {
      profile_id: localStorage.getItem('profile_id') || null,
      token: localStorage.getItem('token_set') || '',

      orderDateTime: currentDateTime,
      unloadingDateTime: currentDateTime,
      currentDateTime,
      loading: false,
      loading2: false,
      bootstraplist: [],
      distributor: '',
      vehicle: '',
      plant: '',
      destination: '',
      bridging: '',
      britype: '',
      remark: '',
      distributors: [],
      vehicles: [],
      plants: [],
      bridgings: [],
      britypes: [],
      errors: {},
    };
  },

  setup() {
    const router = useRouter();
    return { router };
  },

  computed: {
    formattedBootstrapList() {
      return this.bootstraplist.map(item => ({
        item_id: item.id,
        qty: item.qty || 0,
        cost: item.cost || 0,
        current_stock: item.current_stock || 0
      }));
    },

    isFormValid() {
      return (
          this.orderDateTime &&
          this.unloadingDateTime &&
          this.distributor &&
          this.bridging &&
          this.britype &&
          this.plant &&
          this.destination
      );
    }
  },

  methods: {
    adjustTextareaHeight() {
      this.$nextTick(() => {
        const textarea = this.$refs.remarkTextarea;
        textarea.style.height = "auto"; // Reset height to recalculate
        textarea.style.height = `${textarea.scrollHeight}px`; // Set to scrollHeight
      });
    },

    async fetchDistributors() {
      try {
        const response = await fetchDistributorListOrderRequest(this.profile_id, this.token);
        if (response.data.status === "success") {
          this.distributors = response.data.data;
        } else {
          this.errors.distributors = response.data.message;
        }
      } catch (error) {
        this.errors.distributors = "Failed to fetch distributors.";
      }
    },

    async fetchVehicle() {
      try {
        const response = await fetchVehicleListOrderRequest(this.profile_id, this.token);
        if (response.data.status === "success") {
          this.vehicles = response.data.data;
        } else {
          this.errors.vehicles = response.data.message;
        }
      } catch (error) {
        this.errors.vehicles = "Failed to fetch vehicles.";
      }
    },

    async fetchPlant() {
      try {
        const response = await fetchPlantOrderRequest(this.token);
        if (response.data.status === "success") {
          this.plants = response.data.data;
        } else {
          this.errors.plants = response.data.message;
        }
      } catch (error) {
        this.errors.plants = "Failed to fetch plants.";
      }
    },

    async fetchBridgings() {
      try {
        const response = await fetchBridgingList(this.token);
        if (response.data.status === "success") {
          this.bridgings = response.data.data;
        } else {
          this.errors.bridgings = response.data.message;
        }
      } catch (error) {
        this.errors.bridgings = "Failed to fetch bridgings.";
      }
    },

    async fetchVehicleTypes() {
      try {
        const response = await fetchVehicleType(this.token);
        if (response.data.status === "success") {
          this.britypes = response.data.data;
        } else {
          this.errors.britypes = response.data.message;
        }
      } catch (error) {
        this.errors.britypes = "Failed to fetch vehicle types.";
      }
    },

    async fetchItems() {
      this.loading = true;
      const companyId = localStorage.getItem('company_id');
      const isparent  =1;
      try {
        const response = await fetchItemNameListOrder(companyId,isparent,this.token);
        if (response.data.status === "success") {
          this.bootstraplist = response.data.data;
        } else {
          this.errors.items = response.data.message;
        }
      } catch (error) {
        this.errors.items = "Failed to fetch items.";
      } finally {
        this.loading = false;
      }
    },

    deleteItem(index) {
      this.$refs.quantityInputs[index].value = '';
    },

    checkItemQuantities() {
      for (let i = 0; i < this.formattedBootstrapList.length; i++) {
        const quantity = this.$refs.quantityInputs[i] ? this.$refs.quantityInputs[i].value : '';
        if (quantity && quantity > 0) {
          // If any item has a non-empty, valid quantity, return true
          return true;
        }
      }
      // If no item has a valid quantity
      return false;
    },

    async issueGatePass() {
      if (!this.checkItemQuantities()) {
        const toast = useToast();
        toast.error('Please add at least one item.');

      } else {
        this.loading2 = true;  // Set loading to true when request starts
        const toast = useToast();
        const payload = {
          distributor_id: this.distributor,
          created_by: localStorage.getItem('profile_id'),
          loading_date_time: this.orderDateTime,
          unload_date_time: this.unloadingDateTime,
          bridging_id: this.bridging,
          vehicle_type: this.britype,
          vehicle_no: String(this.vehicle),
          gas_plant_id: this.plant,
          distributor_location: this.destination,
          remarks: this.remark,
          profile_name: localStorage.getItem('profile_name') || '',
          details: this.formattedBootstrapList
              .map((item, index) => ({
                item_id: item.item_id,
                qty: this.$refs.quantityInputs[index].value,
                cost: item.cost,
                current_stock: item.current_stock
              }))
              .filter(item => item.qty)
        };

        try {
          const response = await savePurchaseOrder(payload, this.token);
          if (response.data.status === "success") {
            toast.success("Purchase order saved successfully!");
            this.$router.push('/order-request-history');
          } else {
            toast.error(response.data.message);
            this.$router.push('/order-create');
          }
        } catch (error) {
          toast.error("Failed to save purchase order.");
        } finally {
          this.loading2 = false; // Reset loading state after the request
        }
      }


    }
  },

  mounted() {
    this.fetchDistributors();
    this.fetchVehicle();
    this.fetchVehicleTypes();
    this.fetchPlant();
    this.fetchBridgings();
    this.fetchItems();
  }
};
</script>

<style scoped>

/* Prevent number input scroll changes */
input[type="number"] {
  -moz-appearance: textfield;
}

.quantity-input {
  width: 100px; /* Adjust the width as needed */
}
/* Styling for labels */
label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  font-size: 14px; /* Adjust font size for better readability */
}

/* Styling for select elements */
select {
  width: 100%; /* Ensure select takes full width of its container */
  padding: 10px; /* Add padding to the select elements */
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px; /* Adjust font size for better readability */
  transition: border-color 0.3s, box-shadow 0.3s;
}

/* Styling for search input */
.search-input {
  flex: 1;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px; /* Adjust font size for better readability */
  transition: border-color 0.3s, box-shadow 0.3s;
}

/* Common styles for all input fields */
.search-input,
input[type="datetime-local"],
select,
textarea {
  width: 100%; /* Ensure all inputs take full width of their parent */
  height: 40px; /* Set a fixed height for all input fields */
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px;
  transition: border-color 0.3s, box-shadow 0.3s;
}

#destination {
  resize: none;
  overflow: hidden;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table th, .table td {
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.table th {
  background-color: #f9f9f9;
  font-weight: bold;
}

.table td {
  background-color: #ffffff;
}

/* Popup styling */
.popup-content h3 {
  margin-top: 0;
}

.popup-content ul {
  list-style: none;
  padding: 0;
}

.popup-content li {
  margin-bottom: 10px;
}

.popup-content hr {
  border: 0;
  border-top: 1px solid #ddd;
  margin: 10px 0;
}

/* Optional: Add spacing and icon styling for the complaint messages */
.table td i {
  margin-right: 8px; /* Space between icon and text */
  color: red; /* Color of the flag icon */
}

/* Styling for the "eye" icon */
.fa-trash {
  cursor: pointer;
  transition: color 0.3s, transform 0.3s; /* Smooth transition for color and transform */
}

/* Hover effect for the "eye" icon */
.fa-trash:hover {
  color: #ee164d; /* Darker shade on hover */
  transform: scale(1.2); /* Slightly enlarge the icon on hover */
}

/* Active effect for the "eye" icon */
.fa-trash:active {
  transform: scale(1.1); /* Slightly shrink the icon on click */
}

/* Loading spinner styles */
.loading-spinner {
  font-size: 18px;
  text-align: center;
  margin-top: 20px;
  color: #007bff; /* Preserved color for spinner */
}

/* New styles for the remark section */
.remark-section {
  margin-top: 20px;
}

.remark-section label {
  font-weight: bold;
  font-size: 14px;
}

.remark-section textarea {
  width: 100%;
  height: 80px; /* Set a fixed height for all input fields */
  padding: 10px 20px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px;
}

/* Common styles for all input fields */
.search-input:focus,
input[type="datetime-local"]:focus,
select:focus,
textarea:focus {
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(38, 143, 255, 0.5);
  outline: none;
}

</style>